import { render, staticRenderFns } from "./ShowClipartLayers.vue?vue&type=template&id=24113e98&scoped=true"
import script from "./ShowClipartLayers.vue?vue&type=script&lang=js"
export * from "./ShowClipartLayers.vue?vue&type=script&lang=js"
import style0 from "./ShowClipartLayers.vue?vue&type=style&index=0&id=24113e98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24113e98",
  null
  
)

export default component.exports